/* tslint:disable */
/* eslint-disable */
// this is an auto generated file. This will be overwritten

import * as APITypes from "../API";
type GeneratedSubscription<InputType, OutputType> = string & {
  __generatedSubscriptionInput: InputType;
  __generatedSubscriptionOutput: OutputType;
};

export const showTransferOnDisplay = /* GraphQL */ `subscription ShowTransferOnDisplay($id: String, $ownerNarwhalId: String) {
  showTransferOnDisplay(id: $id, ownerNarwhalId: $ownerNarwhalId) {
    amount
    authUrl {
      gotoUrl
      gotoUrlQr
      __typename
    }
    currency
    date
    details {
      avatar
      companyPreferences {
        guestCheckout
        __typename
      }
      name
      type
      __typename
    }
    direction
    id
    isAccepted
    isError
    isInitiated
    isSettled
    note
    ownerNarwhalId
    serviceProviderName
    statementReference
    status
    vatAmount
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.ShowTransferOnDisplaySubscriptionVariables,
  APITypes.ShowTransferOnDisplaySubscription
>;
export const updatedTransfer = /* GraphQL */ `subscription UpdatedTransfer($id: String, $ownerNarwhalId: String) {
  updatedTransfer(id: $id, ownerNarwhalId: $ownerNarwhalId) {
    amount
    authUrl {
      gotoUrl
      gotoUrlQr
      __typename
    }
    currency
    date
    details {
      avatar
      companyPreferences {
        guestCheckout
        __typename
      }
      name
      type
      __typename
    }
    direction
    id
    isAccepted
    isError
    isInitiated
    isSettled
    note
    ownerNarwhalId
    serviceProviderName
    statementReference
    status
    vatAmount
    __typename
  }
}
` as GeneratedSubscription<
  APITypes.UpdatedTransferSubscriptionVariables,
  APITypes.UpdatedTransferSubscription
>;
